import * as React from 'react';
import { SVGProps } from 'react';

const IconDiamondSizeS = (props: SVGProps<SVGSVGElement>) => (
  <svg viewBox="0 0 16 16" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path d="M13 6h-3l1.6-4H4L0 5.9l7.266 8.265L4 6h4v9l8-9.1-3.752-3.658L13 6z" />
  </svg>
);
export default IconDiamondSizeS;
